"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ConfirmModal = function (_a) {
    var closeModalHandler = _a.closeModalHandler, isLoading = _a.isLoading, confirmHandler = _a.confirmHandler;
    var t = (0, next_intl_1.useTranslations)('translation');
    return (react_1.default.createElement(ui_components_1.Modal, { width: "400px", height: "auto", saveSize: true, portalNodeId: "modal", onClose: closeModalHandler },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, t("youSureCancelWithdrawal")),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonsContainer },
                react_1.default.createElement(ui_components_1.FixedButton, { color: "green", text: "upper", onClick: closeModalHandler }, t('no')),
                react_1.default.createElement(ui_components_1.FixedButton, { color: "red", text: "upper", onClick: confirmHandler, loading: isLoading }, t('yes'))))));
};
exports.default = ConfirmModal;
